import { connect } from 'react-redux';
import { withRouter as _withRouter } from 'react-router-dom';

const withRouter = (useRouter) => (Component) => (useRouter ? _withRouter(Component) : Component);

export default (mapState, mapDispatch, { mergeProps, useRouter, options } = {}) => (Component) =>
    withRouter(useRouter)(connect(mapState, mapDispatch, mergeProps, options)(Component));
